import React from 'react';
import Link from 'next/link';

const PromotionalBanner = () => {
  // Check if banner should be shown based on environment variable
  const showBanner = process.env.NEXT_PUBLIC_SHOW_PROMO_BANNER !== 'false';
  
  // Don't render if banner is disabled
  if (!showBanner) {
    return null;
  }

  return (
    <div className="bg-primary text-white py-3 px-4 relative">
      <div className="container-custom">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">

            
            {/* Message */}
            <div className="flex-1">
              <p className="text-sm md:text-base font-medium">
                Personalia has launched! 
                <span className="hidden sm:inline ml-2">
                  Have questions, or would like a demonstration?
                </span>
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            {/* CTA Button */}
            <Link 
              href="/contact?subject=sales"
              className="bg-white text-primary hover:bg-gray-100 px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap"
            >
              Contact Us
            </Link>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromotionalBanner;
